import { RootState } from "integrations/redux"
import {
    AuthenticationChallengeIndicators,
    AuthenticationSliceState,
    PasswordPolicyResponse,
} from "./types"

const root = (state: RootState): AuthenticationSliceState => state.application.user.authentication

export const selectAuthenticationLoading = (state: RootState): boolean => root(state).isLoading
export const selectIsVerifyingSso = (state: RootState): boolean => root(state).isVerifyingSso
export const selectIsAuthenticated = (state: RootState): boolean => root(state).isAuthenticated
export const selectIsRefreshingCredentials = (state: RootState): boolean =>
    root(state).isRefreshingCredentials
export const selectNeedsCredentialsRefresh = (state: RootState): boolean =>
    root(state).needsCredentialRefresh
export const selectAuthenticationChallenge = (
    state: RootState
): AuthenticationChallengeIndicators | undefined => root(state).challenge
export const selectPasswordPolicy = (state: RootState): PasswordPolicyResponse | undefined =>
    root(state).passwordPolicy
export const selectAuthenticationErrorMessage = (state: RootState): string | undefined =>
    root(state).authenticationErrorMessage
